import { render, staticRenderFns } from "./ApproveUser.vue?vue&type=template&id=af58a640"
import script from "./ApproveUser.vue?vue&type=script&lang=js"
export * from "./ApproveUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports